// extracted by mini-css-extract-plugin
export default {"thumb":"Gb9DI"};